/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function Buttons(props) {
	const { t } = useTranslation();
	return (
		<Grid id="shadow-round" item sm={6} spacing={2} xs={12}>
			<Button
				aria-label="add"
				disabled={props.disabled}
				fullWidth
				id={props.id}
				onClick={props.action}
				type="submit">
				{t(props.name)}
				{props.isLoading ? <CircularProgress disableShrink size={18} style={{ color: 'white' }} /> : ''}
			</Button>
		</Grid>
	);
}

export default hot(module)(Buttons);
